
import SsrCarousel from 'vue-ssr-carousel'
import { mapGetters, mapActions } from 'vuex'
export default {
  components:{SsrCarousel},
  props: {
    id: {
      default: '',
      type: String,
    },
    region: {
      default: 'uk',
      type: String,
    },
  },
  data() {
    return {
      // isVisible:false
      // recognised: this.region === 'uk' ? 'recognised' : 'recognized',
      centre: this.region === 'uk' ? 'centre' : 'center',
      carouselLoaded: false,
      settingsCareers: {
        slidesToScroll: 6,
        slidesToShow: 6,
        autoplay: true,
        fade: false,
        lazyLoad: "ondemand",
        responsive: [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
              "infinite": true,
              "dots": true
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 2,
              "initialSlide": 2
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      activeModal: 'pages/getActiveModal',
    }),
  },
  created() {
    this.setCarouselLoaded();
  },
  beforeUpdate() {
    this.setCarouselLoaded();
  },
  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
    }),
    updateModal(id) {
      this.updateActiveModal(id)
      console.log('Active Modal: ', this.activeModal)
    },
    setCarouselLoaded() {
      // console.log('Checking slots... ',!!this.$slots.default && !!this.$slots.default[0])
      this.carouselLoaded = !!this.$slots.default && !!this.$slots.default[0]
      console.log('carouselLoaded ',this.carouselLoaded)
    },
  },
  
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  }
}
